import React from "react";
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import withShowToast from '../../../hocs/with_show_toast.js';
import withCurrentUser from '../../../hocs/with_current_user.js';
import { compose } from 'redux';

import HtmlContent from "../../../base/components/html_content.js.jsx";
import I18n from "../../../base/i18n.js.jsx";

import FormFields from "../../../base/form/form_fields.js";
import Button from "../../../base/buttons/button.js";
import Checkbox from "../../../base/inputs/checkbox.js";

import BaseSessionPage from "./components/base_session_page.js.jsx";

import URLParams from "../../../utils/url_params.js";

import { SignUpInfoModel } from "../../../models/session/sign_up_info_model.js";
import { SignUpCompanyModel } from "../../../models/session/sign_up_company_model.js";

import CompleteRegistrationInfoUseCase from "../../../use_cases/sessions/complete_registration_info_use_case.js";
import CompleteRegistrationUseCase from  "../../../use_cases/sessions/complete_registration_use_case.js";

import IFrame from "../../../base/components/iframe.js";

import Routes from "../../routes.js";

import Analytics from "../../../utils/analytics";

const styles = theme => ({
  iframe: {

  },
  form: {
    position: "relative",
  },
  hiddenField: {
    display: "block",
    height: "0px",
    padding: "0px",
    border: "none"
  },
  agreementRow: {
    marginTop: "32px",
    alignItems: "flex-start",
    "& .MuiCheckbox-root": {
      marginTop: "-9px"
    },
    color: theme.palette.grayText,
    fontSize: "16px",
    "& a": {
      color: theme.palette.grayText,
    },
    "& .MuiFormControlLabel-label": {
      ['@media (max-width: 768px)']: {
        fontSize: "11px"
      }
    }
  },
  button: {
    margin: "16px 0px",
    width: "100%",
  },
});

const IFrameId = "iframe";

class CompleteRegistrationPage extends React.Component {

  constructor(props) {
    super(props);

    this.confirmationToken = URLParams.get("confirmation_token");
    this.projectSlug = URLParams.get("project_slug");

    this.signUpInfo = {
    }

    this.onItemChange  = this.onItemChange.bind(this);
    this.onChangeAgree = this.onChangeAgree.bind(this);

    this.onSubmit = this.onSubmit.bind(this);

    this.completeRegistration = this.completeRegistration.bind(this);

    this.state = {
      ...this.state,
      formFields: SignUpInfoModel.formFields(),
      agreeWithTerms: false,
      loading: false,
      email: ""
    }
  }

  componentDidMount() {
    CompleteRegistrationInfoUseCase.execute(this.confirmationToken)
    .then((result) => {
      const { data: { user: { email } } } = result;
      this.setState({
        email: email
      })
    })
  }

  onItemChange(changedItem) {
    const salutation = changedItem.personalInfo && changedItem.personalInfo.salutation
    if (salutation == "firma") {
      const newState = Object.assign({}, this.state);
      newState.formFields = SignUpCompanyModel.formFields();
      this.setState(newState);
    }

    const person = ["herr", "frau", "***"]
    if (person.includes(salutation)) {
      const newState = Object.assign({}, this.state);
      newState.formFields = SignUpInfoModel.formFields();
      this.setState(newState);
    }
    this.signUpInfo = changedItem;
    this.signUpInfo.passwordConfirmation = this.signUpInfo.password;
  }

  onChangeAgree(value) {
    this.setState({
      agreeWithTerms: value
    })
  }

  onSubmit(event) {
    this.completeRegistration();
  }

  completeRegistration() {
    this.setState({
      submit: true,
      errorData: undefined
    });
    CompleteRegistrationUseCase.execute(this.confirmationToken,
                                        this.signUpInfo)
    .then((result) => {
      const { data: { user } } = result;
      Analytics.registrationCompleted(user);
      const { history } = this.props;
      this.props.loadUser(() => {
        let url = Routes.xavin()
        if(this.projectSlug) {
          url = Routes.project(this.projectSlug);
          history.replace({
            pathname: url,
            state: { openModal: true }
          });
        }
        else {
          history.replace(url);
        }
      });
    })
    .catch((result) => {

      const { errorData } = result;
      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);
    });
  }

  render() {
    const { classes } = this.props;
    const { submit, formFields, errorData, agreeWithTerms, email, loading } = this.state;
    return <BaseSessionPage title = { I18n.t("shared.sign_up") } >
      <form onSubmit = { this.onSubmit }
            className = { classes.form }
            target = { IFrameId }
            action = { "#" }
            autoComplete = { "on" } >
        <input type = { "text" }
               name = { "username" }
               id = { "username" }
               value = { email }
               className = { classes.hiddenField }
               onChange = { () => { } }/>
        <FormFields formFields = { formFields }
                    item = { this.signUpInfo }
                    errorData = { errorData }
                    onItemChange = { this.onItemChange }
                    defaultWeight = { 12 } />
        <Checkbox checked = { agreeWithTerms }
                  onChange = { this.onChangeAgree }
                  className = { classes.agreementRow }
                  displayName = {
                    <HtmlContent className = { classes.agreementText } >
                      { I18n.t("web.page.complete_registration.agreement", {
                          terms_and_conditions: Routes.termsAndConditions(),
                          data_protection: Routes.dataProtection()
                        }) }
                    </HtmlContent>
                  }  />
        <Button className = { classes.button }
                type = { "submit" }
                disabled = { submit || !agreeWithTerms || loading } >
          { I18n.t("action.join_now") }
        </Button>
      </form>
      <IFrame width = { "0px" }
              height = { "0px" }
              src = { "blank_submit.html" }
              id = { IFrameId }
              name = { IFrameId } />
    </BaseSessionPage>
  }
}

export default compose(withRouter, withShowToast, withCurrentUser, withStyles(styles))(CompleteRegistrationPage)
